import {Component} from '@angular/core';

import {PersonSearchComponent} from "../../person-search/person-search.component";

@Component({
    selector: 'pm-person-search-consultant-component',
    templateUrl: './person-search-consultant.component.html',
    standalone: false,
})
export class PersonSearchConsultantComponent
    extends PersonSearchComponent {


    ngOnInit() {
        super.ngOnInit();
    }


    // /**
    //  * Refresh Component.
    //  */
    // override refreshComponent() {
    //
    //     if (this.defaultDto) {
    //         const formValues = this.myForm.value;
    //         formValues.gender = this.defaultDto['gender'];
    //         formValues.firstName = this.defaultDto['firstName'];
    //         formValues.lastName = this.defaultDto['lastName'];
    //
    //         this.myForm.patchValue(formValues);
    //     }
    //
    //     this.uiMode = "search";
    //
    //     if (this.targetObjectType) {
    //         this.loadMetaForTarget();
    //     } else {
    //         this.refreshComponentDelayed();
    //     }
    //
    // }













    // getObjectRequestComplex(): ObjectRequestComplex | null {
    //
    //     if (!this.targetObjectType) {
    //         return null;
    //     }
    //
    //     // check the connection to the person
    //     let personJoin: MetaDataJoinDto = this.getTargetObjectJoin();
    //
    //     if (!personJoin) {
    //         return null;
    //     }
    //
    //     return ObjectRequestComplex.build(true, false,
    //         ObjectRequestComplexNode.createRelationNode(this.prefixLatestTargetObject + this.targetObjectType, ObjectRequestRelation.createLatest(this.targetObjectType, personJoin.attributeName)),
    //
    //         ObjectRequestComplexNode.createRelationNode('count' + this.targetObjectType,
    //             ObjectRequestRelation.createGroupBy(this.targetObjectType, personJoin.attributeName,
    //                 ObjectRequestListGroupBy.create(true, [], [], [personJoin.attributeName],
    //                     [new ObjectRequestListAttribute(personJoin.attributeName, "Anzahl", DtoListAttributeRequestAggregateEnum.count)])))
    //     );
    //
    // }
















    // uiSwitchToCreateTarget(personId: number) {
    //     const personJoin: MetaDataJoinDto = this.getTargetObjectJoin();
    //
    //     this.targetObjectDefaultCreateDto = new DtoDetail({});
    //     this.targetObjectDefaultCreateDto[personJoin.attributeName + "DtoId"] = personId;
    //
    //     //combining the default dto sent from caller component with personDtoId as a default
    //
    //     const combinedDefaultCreateDto: DtoDetail = new DtoDetail({
    //         ...this.targetObjectDefaultCreateDto,
    //         ...this.createDefaultDto
    //     });
    //
    //     this.targetObjectDefaultCreateDto = combinedDefaultCreateDto;
    //     this.uiMode = 'createTarget';
    //
    //
    // }



}
